// src/pages/Portfolio.js
import React from "react";
import PortfolioShowcase from "./PortfolioShowcase";

const Portfolio = () => {
  return (
    <div>
      <PortfolioShowcase />
    </div>
  );
};

export default Portfolio;